export default {
    DatabaseCookieName: 'Vats_UserDBName',
    LocationParamPath: '$route.params.location',
    ExcelMimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    OctetMimeType: 'application/octet-stream',
};
